/*
 * @Des: 首页查询缴费组件
 * @Author: ***
 * @Date: ***
 * @Last Modified by: chentingrui
 * @Last Modified time: 2023-06-Tu 07:00:04
*/
<template>
  <div class="plate-input-container">
    <div class="main-container">
      <div class="top-title">请输入车牌号码</div>
      <!-- 车牌输入框 -->
      <div id="plate-input" class="input-container">
        <div class="input-list">
          <div v-for="(input, index) in inputList" :key="index" class="input-item">
            <input
              type="text"
              readonly
              maxlength="1"
              :style="{ 'font-size': inputs[index] && inputs[index].value.length>1? '16px': '22px' }"
              :class="{ 'focus': inputInx == index, 'lastInput': index===inputList.length-1 }"
              :data-keyset="keySet(input.keyset)"
              :data-layout="input.layout"
              :data-spkeyset="input.spKeySet"
              :placeholder="placeholder[index]"
              @focus=" (e) => { show(e, index) }"
            >
            <!-- 最后一位的placeholder没法竖着展示 -->
            <div v-if="index ===inputList.length-1 && !haveLastValue" class="placeholde-mock" :style="{'border-style': inputInx ===inputList.length-1?'solid': 'dashed'}">
              <span>新</span>
              <span>能</span>
              <span>源</span>
            </div>
          </div>

        </div>
        <van-checkbox v-model="isYellow" icon-size="20px" class="isYellow">
          大中型车辆（黄牌车）
        </van-checkbox>
        <!-- 查询按钮 -->
        <div class="add-btn" :class="searchBtnDisabled ?'disabled': ''" @click="handleBtnClick">{{ searchBtnText }}</div>
        <transition>
          <key-borad
            v-if="isKeyBoardShow"
            id="key-board"
            :close="close"
            :next="next"
            :previous="previous"
            :update-value="updateCarnum"
            :input="inputEl"
            :current-key-set="keyset"
            :sp-key-set="spKeySet"
            :show-cancel="true"
            :layout="layout"
            @cancel="hide"
            @setKeySet="setKeySet"
            @clickKeyBoard="clickKeyBoard"
          />
        </transition>
      </div>

      <!-- 历史搜索 -->
      <div class="history-tag-list">
        <van-tag
          v-for="(item, index) in historyTag"
          :key="index"
          size="medium"
          color="#fff"
          text-color="#333333"
          closeable
          style="margin-right: 12px"
          @close="closeTag(item.id)"
          @click="handleTagClick(item)"
        >{{ formatePlateNo(item.plateNo) }} {{ item.plateColor===2?'(黄牌车)': '' }}</van-tag>
      </div>
    </div>
  </div>
</template>

<script>
import KeyBorad from '@/components/Keyborad'
import isArray from 'lodash/isArray'
import api_parking from '@/api/parking/index.js'
import { getLocal } from '@/utils/index'
import { Toast } from 'vant'
import _axios from '@/utils/service'
import { Checkbox } from 'vant'

const WJreg = /^WJ[^A-Z]/
const YJreg = /应急*/

const nromalKeyBoard = [
  { layout: 'area', keyset: 'defaultOn' },
  { layout: 'area', keyset: 'abc' },
  { layout: 'area', keyset: 'num' },
  { layout: 'area', keyset: 'num' },
  { layout: 'area', keyset: 'num' },
  { layout: 'area', keyset: 'num' },
  { layout: 'area', keyset: 'num', spKeySet: 'GAJ' },
  { layout: 'area', keyset: 'num' }
]

const wjKeyBoard = [
  { layout: 'area', keyset: 'defaultOn' },
  { layout: 'area', keyset: 'default' },
  { layout: 'area', keyset: 'num' },
  { layout: 'area', keyset: 'num' },
  { layout: 'area', keyset: 'num' },
  { layout: 'area', keyset: 'num' },
  { layout: 'area', keyset: 'num', spKeySet: 'GAJ' },
  { layout: 'area', keyset: 'num' }
]

export default {
  name: 'PlatenoInput',
  components: { KeyBorad, VanCheckbox: Checkbox },
  props: {
    searchBtnText: {
      type: String,
      default: '查询缴费'
    }
  },
  data() {
    return {
      inputEl: null, // 当前选中input元素
      isKeyBoardShow: false, // 展示隐藏键盘标志
      layout: '', // 传递给键盘组件布局参数
      keyset: '', // 传递给键盘组件布局参数
      spKeySet: '', // 传递给键盘组件【殊】布局参数
      inputInx: 0, // 当前的index
      inputs: [], // 所有的inputs框
      historyTag: [],
      input0Value: '',
      haveLastValue: false, // 最后一位有没有值
      searchBtnDisabled: true,
      isYellow: false,
      inputList: nromalKeyBoard,
      placeholder: '省A12345'
    }
  },
  mounted() {
    this.inputs = [...document.querySelectorAll('input')]
    this.getHistory()
  },
  activated() {
    this.carNum = ''
    this.inputs.forEach((input) => { input.value = '' })
  },
  methods: {
    getPlaceholder(index) {
      if (index === 0) {
        return '省'
      }
      return ''
    },
    setSearchBtn() {
      if (!this.inputs.length) {
        this.searchBtnDisabled = true
      } else {
        let flag = false
        for (let i = 0; i < this.inputs.length - 1; i++) {
          if (this.inputs[i].value === '') {
            flag = true
            break
          }
        }
        this.searchBtnDisabled = flag
      }
    },
    // 删除历史查询记录
    async closeTag(recordId) {
      await _axios({
        url: '/charge/v2/api/plateHistory/record',
        method: 'delete',
        params: {
          recordId
        }
      })
      this.getHistory()
    },
    async getHistory() {
      const res = await _axios('/charge/v2/api/plateHistory/record')
      this.historyTag = res.data
    },
    formatePlateNo(plateNo) {
      // WJ车牌 加点
      if (plateNo.match(/^WJ/)) {
        return `${plateNo.substring(0, 3)} ${plateNo.substring(3)}`
      }
      // 警或者应急结尾 加点
      if (plateNo.match(/(警|应急)$/)) {
        return `${plateNo.substring(0, 1)}·${plateNo.substring(1)}`
      }
      // 其他加点
      return `${plateNo.substring(0, 2)}·${plateNo.substring(2)}`
    },
    setKeySet(keyset) {
      this.keyset = keyset
    },
    keySet(key) {
      const keyset = key
      if (isArray(keyset)) {
        return keyset[this.cardType]
      }
      return keyset
    },
    hide() {
      this.isKeyBoardShow = false
      if (this.inputs.every(item => item.value === '')) {
        this.placeholder = '省A12345'
      }
    },
    clickKeyBoard() {
      const that = this
      if (that.inputs.every(item => item.value == '')) {
        that.placeholder = '省A12345'
      }
    },
    close() {
      this.inputEl.blur()
      this.hide()
    },
    next() {
      this.updateCarnum()
      this.$nextTick(() => {
        if (this.inputInx < this.inputs.length - 1) {
          this.inputs[this.inputInx + 1].focus()
        } else {
          this.inputEl.blur()
          this.inputEl = null
          this.hide()
        }
      })

      // const inputs = document.querySelectorAll('input')
      // let found = false;
      // [].forEach.call(inputs, (item, i) => {
      //   if (!found && item === this.inputEl && i < inputs.length - 1) {
      //     found = true
      //     this.$nextTick(() => {
      //       inputs[i + 1].focus()
      //     })
      //   }
      // })
      // if (!found) {
      //   this.inputEl.blur()
      //   this.inputEl = null
      //   this.hide()
      // }
    },
    previous() {
      this.updateCarnum()
      this.$nextTick(() => {
        if (this.inputInx > 0) {
          this.inputs[this.inputInx - 1].value = ''
          this.inputs[this.inputInx - 1].focus()
        } else {
          this.inputEl.blur()
          this.inputEl = null
          this.hide()
        }
      })

      // const inputs = document.querySelectorAll('input')
      // let found = false;
      // [].forEach.call(inputs, (item, i) => {
      //   if (!found && item == this.inputEl && i > 0) {
      //     found = true
      //     this.$nextTick(() => {
      //       inputs[i - 1].focus()
      //       inputs[i - 1].value = ''
      //     })
      //   }
      // })
      // if (!found) {
      //   this.inputEl.blur()
      //   this.inputEl = null
      //   this.hide()
      // }
    },

    show(e, index) {
      document.activeElement.blur()
      // 当用户啥也没输时，点哪里都选中第一位
      if (this.inputs.every(item => item.value === '')) {
        // this.inputInx = this.$store.state.user.paramConfig.province.length || 0
        if (!this.isKeyBoardShow) {
          this.placeholder = ''
          if (this.$store.state.user.paramConfig.province) {
            this.inputs[0].value = this.$store.state.user.paramConfig.province ? this.$store.state.user.paramConfig.province[0] : ''
            this.inputs[1].value = this.$store.state.user.paramConfig.province[1] ? this.$store.state.user.paramConfig.province[1] : ''
            this.inputEl = this.inputs[this.$store.state.user.paramConfig.province.length || 0]
            this.inputInx = this.inputs[1].value ? 2 : (this.inputs[0].value ? 1 : (this.isKeyBoardShow ? 0 : this.$store.state.user.paramConfig.province.length))
          }
        } else {
          this.inputEl = e.target
          this.inputInx = index
        }
        // this.inputInx = this.inputs[1].value ? 2 : 1
        console.log(666, this.inputInx)
      } else {
        this.inputEl = e.target
        this.inputInx = index
        console.log(555, this.inputInx)
      }
      this.isKeyBoardShow = true
      this.layout = this.inputList[this.inputInx].layout
      this.keyset = this.inputList[this.inputInx].keyset || 'default'
      this.spKeySet = this.inputList[this.inputInx].spKeySet || 'off'
    },

    // 车牌回填：先将特殊车牌变成普通车牌再回填
    reSetPlate(plateNo) {
      let plate = plateNo
      const isWJ = WJreg.test(plate)
      const isYJ = YJreg.test(plate)
      if (isWJ) {
        plate = plate.replace(/^WJ/, '-')
      }
      if (isYJ) {
        plate = plate.replace(/应急/, '-')
      }
      const res = this.reSetNormalPlate(plate)
      if (isWJ) {
        res[0] = 'WJ'
      }
      if (isYJ) {
        res[6] = '应急'
      }
      if (plate.length < 8) {
        res[7] = ''
      }
      this.inputs.forEach((item, index) => {
        item.value = res[index]
      })
      this.updateCarnum()
    },
    // 普通车牌的回填
    reSetNormalPlate(plateNo) {
      const res = this.inputs.map(item => item.value)
      const plateList = plateNo.split('')
      res.splice(0, plateList.length, ...plateList)
      return res
    },

    updateCarnum() {
      this.input0Value = this.inputs[0].value
      if (this.inputs[0].value === 'WJ') {
        this.inputList = wjKeyBoard
        if (this.inputs[1].value.match(/^[A-Z]/)) {
          this.inputs[1].value = ''
        }
      } else {
        this.inputList = nromalKeyBoard
      }
      this.haveLastValue = this.inputs[this.inputs.length - 1].value !== ''
      this.setSearchBtn()
    },

    handleBtnClick() {
      if (!this.searchBtnDisabled) {
        const valueList = this.inputs.map(item => item.value)
        const plateNo = valueList.join('')
        this.submitCarnum(plateNo, this.isYellow, false)
      }
    },

    handleTagClick(item) {
      const { plateNo, plateColor } = item
      const isYellow = plateColor === 2
      this.submitCarnum(plateNo, isYellow)
    },

    submitCarnum(plateNo, isYellow, isNeedReset = true) {
      if (isNeedReset) {
        this.isYellow = isYellow
        this.reSetPlate(plateNo)
      }
      const plateColor = isYellow ? 2 : ''
      api_parking
        .plateNo({
          plateNo,
          plateColor,
          dealerId: getLocal('driverDealerId')
        })
        .then((res) => {
          if (res.data.count === 0) {
            this.getHistory()
            Toast('未查到待缴费信息')
          } else {
            if (res.data.count === 1) {
              this.$router.push({
                path: '/payPage',
                query: {
                  uniqueId: res.data.uniqueId,
                  isArreas: res.data.arrearsOnly,
                  parkId: res.data.parkId + ''
                }
              })
            } else {
              this.$router.push({
                path: '/multiPayPage',
                query: {
                  plateNo,
                  plateColor,
                  arrearsOnly: res.data.arrearsOnly
                }
              })
            }
          }
        })
    }
  }
}
</script>

<style lang="less" scoped>
.plate-input-container {
  padding: 0 10px;
  box-sizing: border-box;
  z-index: 99;
  .main-container {
    padding-bottom: 12px;
    border-radius: 12px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 1px rgba(226, 226, 226, 0.5);
    .top-title {
      width: 150px;
      height: 34px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #333333;
      font-weight: 400;
      background: url('~@/assets/home_chaxunjiaofei.png') no-repeat 0;
      background-size: cover;
      margin-bottom: 20px;
      padding-right: 28px;
      box-sizing: border-box;
    }
    .input-container {
      padding: 0 16px;
      .input-list {
        display: flex;
        justify-content: center;

        // 在这开始循环
        .input-item {
          margin-left: 5px;
          position: relative;
          input {
            width: 36px;
            height: 40px;
            font-size: 22px;
            font-weight: 500;
            text-align: center;
            color: #333;
            background: rgba(65, 130, 244, 0.06);
            border: 1px solid rgba(176, 205, 255, 1);
            border-radius: 4px;
            transition: border-color 0.2s ease-in-out 0s;
            &.focus {
              border-color: rgba(56, 128, 255, 1);
              outline: 0;
            }
            &.lastInput{
              border: 1px dashed rgba(26, 184, 105, 1);
              background: rgba(0, 208, 5, 0.06);
              &.focus {
                border-style: solid;
                outline: 0;
              }
            }
          }
          &:first-child {
            position: relative;
            margin-left: 0px;
            input{
              &::placeholder {
                color: #ddd
              }
            }
          }
          &:first-child::before {
            content: '';
            position: absolute;
            right: 0;
            top: 0;
            border: 5px solid #4182f4;
            border-left: 5px solid transparent;
            border-bottom: 5px solid transparent;
            border-radius: 4px;
          }
          // &:last-child {
          //   input {
          //     background: rgba(0, 208, 5, 0.06);
          //     border: 1px dashed rgba(26, 184, 105, 1);
          //     &::placeholder {
          //       font-size: 10px;
          //       transform: translateY(-4px);
          //     }
          //     &.focus {
          //       border-style: solid;
          //       outline: 0;
          //     }
          //   }
          // }
        }
        .placeholde-mock{
          width: 36px;
          height: 40px;
          font-size: 11px;
          font-weight: 400;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          color: #CCCCCC;
          background: rgba(0, 208, 5, 0.06);
          border: 1px dashed rgba(26, 184, 105, 1);
          border-radius: 4px;
          position: absolute;
          top:0;
          right:0;
          pointer-events: none; // 点击下钻
          z-index: 1;
          span{
            line-height: 12px;
          }
        }
      }

    }
    .isYellow {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #666666;
      letter-spacing: 0;
      text-align: right;
      font-weight: 400;
      width: 100%;
      margin-top:12px;
      display: flex;
      justify-content: flex-end;
    }

    .history-tag-list {
      display: flex;
      align-items: center;
      padding: 0 16px;
      margin-top: 12px;
      .van-tag {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        line-height: 16px;
        color: #333333;
        font-weight: 400;
        letter-spacing: 0.5px;
      }
      .van-icon::before {
        color: #4182f4;
        margin-left: 6px;
        width: 12px;
        height: 12px;
        line-height: 16px;
      }
    }
    .add-btn {
      width: 300px;
      height: 40px;
      border-radius: 2em;
      background-color: #4182f4;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-family: PingFangSC-Medium;
      font-size: 18px;
      font-weight: 500;
      margin: 20px auto 0;
    }
    .add-btn.disabled {
      background-color: #ddd;
    }
  }
}
</style>

